import { BlockTitle } from "@blocks/Blocks";

import ChargesSection from "./ChargesSection";
import JudgingPanelSection from "./JudgingPanelSection";
import JudgingProcessSection from "./JudgingProcessSection";

/**
 * Component to render Judging section for FAQ Page
 */
const JudgingSection = (): React.ReactElement => {
  return (
    <>
      <BlockTitle
        text="Judging Process"
        rootClassName="bg-gray-150 text-2xl md:text-2xl lg:text-2xl font-semibold pb-2 pt-6 pl-4"
      />

      <JudgingPanelSection />

      <ChargesSection />

      <JudgingProcessSection />
    </>
  );
};

export default JudgingSection;
